import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { ReactComponent as InfoIcon } from '../../assets/img/info-icon.svg';
import { Arrow } from '../common/Arrow';

export interface DataDescriptionProps {
  text: string;
  header: string;
}

export const DataDescription = (props: DataDescriptionProps) => {
  const [open, setOpen] = useState(false);
  const displayText = () => {
    setOpen(true);
  };
  const hideText = () => {
    setOpen(false);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '23px',
        padding: '20px',
      }}
      className="graph-description"
    >
      <InfoIcon />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{ color: ' #8B8296;', fontSize: '14px' }}
            variant="body2"
            onMouseOver={displayText}
            onMouseLeave={hideText}
          >
            {props.header}
          </Typography>
          <Arrow open={open}></Arrow>
        </Box>
        {open ? (
          <Typography
            sx={{
              color: ' #8B8296;',
              fontSize: '14px',
              wordWrap: 'wrap',
              maxWidth: '600px',
            }}
            variant="body2"
          >
            {props.text}
          </Typography>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};
